import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAtom } from "jotai"
import { userAtom } from "../state"
import api from "../services/api"

const Home = () => {
  const [user] = useAtom(userAtom)
  const navigate = useNavigate()

  useEffect(() => {
    const handleRedirect = async () => {
      if (!user) {
        return
      }

      // Non-admin, non-guide-admin, non-guide users go straight to plans
      if (!user.is_admin && !user.is_guide_admin && !user.is_guide) {
        navigate("/plan", { replace: true })
        return
      }

      // Guide admins and guides redirect to plan
      if ((user.is_guide_admin || user.is_guide) && !user.is_admin) {
        navigate("/plan", { replace: true })
        return
      }

      const isOrgAdmin = !!(user?.is_admin && !user?.is_super_admin)

      // Super admins (no org) go straight to admin dashboard
      if (user.is_admin && !isOrgAdmin) {
        navigate("/admin", { replace: true })
        return
      }

      // Org admin: check if they have plans
      if (isOrgAdmin) {
        try {
          const response = await api.getPlans({})
          const userPlans = response.data.filter(
            (plan) => plan.user_id === user.id ||
                      plan.users?.some(u => u.id === user.id)
          )

          if (userPlans.length === 0) {
            navigate("/admin", { replace: true })
            return
          }
        } catch (error) {
          console.error("Failed to fetch plans:", error)
        }
      }

      // Org admin with plans goes to their plan
      navigate("/plan", { replace: true })
    }

    handleRedirect()
  }, [user, navigate])

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-gray-600">Loading...</div>
    </div>
  )
}

export default Home
